import React from "react";
import { Check } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

/**
 * "About Tripex" section — a warm intro line, a six-item capability list,
 * then a closing paragraph. Styled to blend with the existing About / Hero
 * sections (kicker chip + emerald deep body). Bullets use a tiny brand-teal
 * check icon so they stand out visually without introducing a new palette.
 */
export default function AboutTripex() {
  const { t, isAr } = useLang();
  const bullets = t("about_tripex_bullets") || [];
  const fontFam = isAr ? "Cairo" : "Plus Jakarta Sans";
  return (
    <section
      id="about-tripex"
      className="reveal relative py-16 md:py-24 overflow-hidden"
      style={{ scrollMarginTop: "90px" }}
      data-testid="about-tripex-section"
    >
      <div className={`relative max-w-3xl mx-auto px-6 md:px-8 ${isAr ? "text-right" : "text-left"}`}>
        <span
          className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold tracking-wide border border-emerald-soft/40 text-emerald-deep bg-cream-light/70 mb-6"
          style={{ fontFamily: fontFam }}
          data-testid="about-tripex-kicker"
        >
          {t("about_tripex_kicker")}
        </span>
        <p
          className="text-lg md:text-2xl leading-relaxed text-emerald-deep font-medium"
          style={{ fontFamily: fontFam }}
          data-testid="about-tripex-intro"
        >
          {t("about_tripex_intro")}
        </p>
        <ul
          className="mt-7 space-y-3"
          style={{ fontFamily: fontFam }}
          data-testid="about-tripex-bullets"
        >
          {bullets.map((label, i) => (
            <li
              key={i}
              className="flex items-start gap-3 text-base md:text-lg text-emerald-deep/90"
            >
              <span
                className="mt-1 shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full"
                style={{ background: "rgba(42,191,191,0.12)", color: "#2ABFBF" }}
                aria-hidden
              >
                <Check size={14} strokeWidth={3} />
              </span>
              <span>{label}</span>
            </li>
          ))}
        </ul>
        <p
          className="mt-8 text-base md:text-lg leading-relaxed text-emerald-deep/80"
          style={{ fontFamily: fontFam }}
          data-testid="about-tripex-closing"
        >
          {t("about_tripex_closing")}
        </p>
      </div>
    </section>
  );
}
